<template>
    <div class="add-to-order">
        <button type="button" class="btn btn-xs" :class="buttonState.class" :title="buttonState.tooltip" @click="showDialog = true">
            <span class="fa" :class="buttonState.icon"></span>
            {{ buttonState.text }}
        </button>

        <div class="text-left">
            <OrderItemDialog
                v-if="showDialog"
                :inventoryItemId="inventoryItemId"
                :vendorId="vendorId"
                :productId="productId"
                @hide="showDialog = false"
                @saved="showDialog = false"
                @deleted="showDialog = false"
                />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    components: {
        OrderItemDialog: require('@/components/orderitems/OrderItemDialog.vue').default,
    },
    props: {
        inventoryItemId: null,
        vendorId: null,
        productId: null,
        orderItems: null,
        onlyShowThisVendor: Boolean,
    },
    data() {
        return {
            showDialog: false,
        };
    },
    computed: {
        ...mapGetters('data', ['orderItemsForProductAndVendorIds']),

        currentOrderItemsForThisVendor() {
            return this.orderItemsForProductAndVendorIds({
                productId: this.productId,
                vendorId: this.vendorId,
            });
        },
        currentOrderItemsForOtherVendors() {
            return this.orderItemsForProductAndVendorIds({
                productId: this.productId,
                vendorId: this.vendorId,
                showOtherVendorsInstead: true,
            });
        },

        hasOrderItems() {
            return this.currentOrderItemsForThisVendor.length > 0
                || this.currentOrderItemsForOtherVendors.length > 0;
        },
        hasOrderItemsForThisVendor() {
            return this.currentOrderItemsForThisVendor.length > 0;
        },
        hasOwnOrderItemForThisVendor() {
            return !!this.currentOrderItemsForThisVendor.find(i => i.user_id == Laravel.userId);
        },
        hasOrderItemsForOtherVendors() {
            return this.currentOrderItemsForOtherVendors.length > 0;
        },

        buttonState() {
            if (this.hasOwnOrderItemForThisVendor) {
                return {
                    text: 'In Order',
                    tooltip: 'You added this item to the vendor\'s current order.',
                    class: 'btn-primary',
                    icon: 'fa-check',
                };
            }

            if (this.hasOrderItemsForThisVendor) {
                return {
                    text: 'In Order',
                    tooltip: 'Item is currently in this vendor\'s order.',
                    class: 'btn-success',
                    icon: 'fa-check',
                };
            }

            if (this.hasOrderItemsForOtherVendors && !this.onlyShowThisVendor) {
                return {
                    text: 'In Order *',
                    tooltip: 'Item is currently in another vendor\'s order.',
                    class: 'btn-warning',
                    icon: 'fa-check',
                };
            }

            return {
                text: 'Add to Order',
                tooltip: 'Item is not currently in any vendor\'s order.',
                class: 'btn-default',
                icon: 'fa-plus',
            }
        },
    },
    watch: {
        orderItems: {
            handler: 'reloadOrderItems',
            immediate: true,
        },
    },
    methods: {
        ...mapActions('data', ['sideloadProductOrderItems']),
        reloadOrderItems() {
            if (this.orderItems)
                this.sideloadProductOrderItems({ orderItems: this.orderItems, productId: this.productId });
        },
    },
};
</script>
